<template>
	<div id="container" ref="subtitleContainer">
		<div id="subtitleContainer">
            <header class="mdc-top-app-bar position-init">
                <div class="mdc-top-app-bar__row">
                    <section class="mdc-top-app-bar__section mdc-top-app-bar__section--align-start">
                        <a class="material-icons mdc-top-app-bar__navigation-icon" @click="onClose()">close</a>
                    </section>
                    
                    <section class="mdc-top-app-bar__section title">
                        <div class="mdc-top-app-bar__title">
                            {{lessonName}}
                        </div>                
                    </section>

                    <section class="mdc-top-app-bar__section mdc-top-app-bar__section--align-end">
                        <a class="material-icons mdc-top-app-bar__action-item" aria-label="search" alt="search"></a>
                    </section>
                </div>
                
            </header>

			
			<section id="subtitlesContainer">
				<div id="subtitles" ref="subtitles">
                    <!-- {{firstTrack}} -->
                    {{secondTrack}}
					<div>

						<ul v-if="firstTrack">
                            <li v-for="(cue) in firstTrack" 
                                :key="cue.startTime" 
                                :ref="`cue_${cue.startTime}`" 
                                :class="{'typography--e-b6': !isLargeText, 'typography--e-b6-large': isLargeText, 'active': cue.startTime === firstTrackStartTime}"
                                :end-data="cue.startTime"
                            >
                                {{cue.text}}

                            </li>
						</ul>
					
                    </div>
				</div>
				<button id="btnTextSize" v-bind:class="{'active': isLargeText}" @click="onLargeText()"></button>
			</section>
		</div>
	</div>
</template>

<script>

export default {
    props: ['firstTrack', 'secondTrack', 'lessonName', 'firstTrackStartTime'],
    data() {
        return {
            isLargeText: false,
            trackFirstSubtitle: null
        }
    },
    mounted() {
        this.setTrack(this.firstTrackStartTime)        
    },
    watch: {
        firstTrackStartTime(activeStartTime) {
            this.setTrack(activeStartTime)
        }
    },
    
    methods: {
        // 자막 트렉 설정(Subtitle Track Settings)
        setTrack(activeStartTime) {
            let element = this.$refs[`cue_${activeStartTime}`]
            this.activeStartTime = activeStartTime
            
            // console.log('elementelement', element);
            if (element) {
                this.moveScroll(element[0])
            }
            
        },

        // 닫기(close)
        onClose: function () {
            this.$emit('subtitles-toggle');
        },
        
        // 자막 폰트 사이즈 설정(Subtitle font size adjustment)
        onLargeText: function () {
            this.isLargeText = !this.isLargeText;
        },

        // 자막 스크롤 이동(Automatic scrolling)
        moveScroll(element) {
            let options = {
                container: this.$refs.subtitles,
                easing: 'ease-in'
            }
            this.$scrollTo(element, 500, options)
        }
    }
}
</script>
